var React = require('react');

function IcShareXCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM14.7148 16.7705L8.5332 23.4668H9.9248L15.335 17.6025L19.707 23.4668H24.4404L17.9541 14.7666L23.7061 8.5332H22.3164L17.333 13.9326L13.3076 8.5332H8.57227L14.7148 16.7705ZM22.3965 22.4375H20.2217L10.6191 9.55957H12.7939L22.3965 22.4375Z","fill":"black"}));
}

IcShareXCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcShareXCircle;

IcShareXCircle.default = IcShareXCircle;
